import axios from 'axios';
import { resolveApiBase } from '../utils/resolveApiBase';

function buildUrl(path, apiVersion) {
  return resolveApiBase(apiVersion) + path;
}

export default {
  get(path, options = {}) {
    var apiVersion = options.apiVersion || 2;
    var config = Object.assign({}, options);
    delete config.apiVersion;

    return axios.get(buildUrl(path, apiVersion), config);
  },

  resolveUrl(path, options = {}) {
    return buildUrl(path, options.apiVersion || 2);
  },

  post(path, data, options = {}) {
    var apiVersion = options.apiVersion || 2;
    var config = Object.assign({}, options);
    delete config.apiVersion;

    return axios.post(buildUrl(path, apiVersion), data, config);
  },

  patch(path, data, options = {}) {
    var apiVersion = options.apiVersion || 2;
    var config = Object.assign({}, options);
    delete config.apiVersion;

    return axios.patch(buildUrl(path, apiVersion), data, config);
  },

  put(path, data, options = {}) {
    var apiVersion = options.apiVersion || 2;
    var config = Object.assign({}, options);
    delete config.apiVersion;

    return axios.put(buildUrl(path, apiVersion), data, config);
  },

  delete(path, options = {}) {
    var apiVersion = options.apiVersion || 2;
    var config = Object.assign({}, options);
    delete config.apiVersion;

    return axios.delete(buildUrl(path, apiVersion), config);
  },
};
